module.exports = __webpack_public_path__ + "img/404-icon.88d85ca2.svg";